import { motion } from "framer-motion";
import { MicroLabel } from "@/components/decor/CropMarks";

const Lockup = () => (
  <svg viewBox="0 0 520 320" className="w-full h-auto" aria-hidden>
    {/* Physical (left) */}
    <g transform="translate(40 60)">
      <rect width="220" height="220" fill="#141414" stroke="rgba(245,241,232,0.4)" />
      <rect x="14" y="14" width="22" height="22" fill="#0072CE" />
      <rect x="14" y="44" width="120" height="3" fill="rgba(245,241,232,0.5)" />
      <rect x="14" y="54" width="80" height="3" fill="rgba(245,241,232,0.35)" />
      <g transform="translate(140 130)">
        <path
          d="M0 0 H40 V40 H0 Z M40 0 H80 Q80 8 88 8 Q96 8 96 16 V40 H40 Z"
          fill="#0A0A0A"
          stroke="#B89B5E"
        />
      </g>
      <text
        x="14"
        y="208"
        fill="#B89B5E"
        style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: 11, letterSpacing: "0.2em" }}
      >
        KRISTER · PHYSICAL
      </text>
    </g>

    {/* Connector */}
    <g transform="translate(260 170)" stroke="#B89B5E" strokeDasharray="3 4">
      <line x1="-12" y1="0" x2="32" y2="0" />
      <circle cx="-12" cy="0" r="3" fill="#B89B5E" stroke="none" />
      <circle cx="32" cy="0" r="3" fill="#B89B5E" stroke="none" />
    </g>

    {/* Digital (right) */}
    <g transform="translate(280 60)">
      <rect width="220" height="220" fill="#0A0A0A" stroke="rgba(245,241,232,0.4)" />
      <rect x="14" y="14" width="22" height="22" fill="#D6007F" />
      <rect x="14" y="44" width="140" height="3" fill="rgba(245,241,232,0.5)" />
      <rect x="14" y="54" width="80" height="3" fill="rgba(245,241,232,0.35)" />
      <g transform="translate(40 110)">
        <rect width="140" height="80" fill="#141414" stroke="rgba(245,241,232,0.35)" />
        <rect x="10" y="12" width="40" height="6" fill="#FFD200" />
        <rect x="10" y="26" width="100" height="3" fill="rgba(245,241,232,0.4)" />
        <rect x="10" y="34" width="80" height="3" fill="rgba(245,241,232,0.3)" />
        <rect x="10" y="58" width="30" height="8" fill="#F5F1E8" />
      </g>
      <text
        x="14"
        y="208"
        fill="#B89B5E"
        style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: 11, letterSpacing: "0.2em" }}
      >
        KREATID · DIGITAL
      </text>
    </g>
  </svg>
);

const KristerKreatid = () => {
  return (
    <section
      data-testid="krister-kreatid"
      className="relative"
      style={{ background: "#0A0A0A", paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <MicroLabel index={10} accent="#B89B5E">
            The Ecosystem
          </MicroLabel>
          <h2
            className="mt-6"
            style={{
              fontFamily: "Montserrat",
              fontWeight: 800,
              color: "#F5F1E8",
              fontSize: "clamp(34px, 4.6vw, 60px)",
              lineHeight: 1,
              letterSpacing: "-0.025em",
              textTransform: "uppercase",
            }}
          >
            Krister
            <br />
            <span style={{ color: "#B89B5E" }}>+ Kreatid.</span>
          </h2>

          <p
            className="mt-8"
            style={{
              color: "#F5F1E8",
              fontSize: "clamp(16px, 1.5vw, 22px)",
              lineHeight: 1.5,
              maxWidth: 480,
              fontWeight: 500,
            }}
          >
            Krister Overseas builds the{" "}
            <span style={{ color: "#B89B5E" }}>physical presence.</span>
          </p>
          <p
            className="mt-3"
            style={{
              color: "#F5F1E8",
              fontSize: "clamp(16px, 1.5vw, 22px)",
              lineHeight: 1.5,
              maxWidth: 480,
              fontWeight: 500,
            }}
          >
            Kreatid Future builds the{" "}
            <span style={{ color: "#B89B5E" }}>strategic and digital identity.</span>
          </p>
          <p
            className="mt-6"
            style={{
              color: "#C0C0C0",
              fontSize: 14,
              lineHeight: 1.75,
              maxWidth: 480,
            }}
          >
            Together, they form a complete offline-to-online branding system — built
            piece by piece, channel by channel.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7 relative"
          style={{
            background: "#0A0A0A",
            border: "1px solid rgba(192,192,192,0.15)",
            padding: "24px",
          }}
        >
          <div
            className="absolute top-3 left-3 ko-overline"
            style={{ color: "#C0C0C0", fontSize: 10 }}
          >
            Lockup · Phase 0
          </div>
          <Lockup />
        </motion.div>
      </div>
    </section>
  );
};

export default KristerKreatid;
